import TagManager from 'react-gtm-module';
import { GTMEECEvent } from './eec';
import { GTMEvent } from './events';
import { GtmPageView } from './pages';

type TagManagerEvent = GtmPageView | GTMEvent | GTMEECEvent;

export const PushEvent = (event: TagManagerEvent): void => {
  TagManager.dataLayer({
    dataLayer: { ...event },
  });
};

export const PushEventWithDelay = (event: TagManagerEvent, delay = 1500) => {
  setTimeout(() => {
    PushEvent(event);
  }, delay);
};
